
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parts/category/[code]",
      function () {
        return require("private-next-pages/parts/category/[code].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parts/category/[code]"])
      });
    }
  